import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import classNames from "classnames";
import React from "react";

export type CardHeaderComponentProps = {};

export type CardHeaderProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, CardHeaderComponentProps, "div">;

const CardHeader = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: CardHeaderProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = classNames(className, "card-header");

    return (
        <Tag
            {...attributes}
            className={classes}
        />
    );
};

export { CardHeader };
